import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TablePagination
} from "@mui/material";
import ExpandableRow from "../ExpandableRow";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import TextPopUp from "../Pop_ups/TextPopUp";
import ClickBox from "../ClickBox";
import SubmittedCell from "./SubmittedCell";
import AddInvoice from "../invoice/AddInvoice";
import {fonts} from '../../util/Theme'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
/**
 * Table Displaying admin's version of submitted timesheets
 * @component 
 * @category Timesheets
 * @subcategory Submitted Timesheets 
 */
function AdminSubmittedDisplay(props, page) {
  const [infoTitle, setInfoTitle] = useState("");
  const [infoBody, setInfoBody] = useState("");
  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");
  const [columnClick, setColumnClick] = useState(false)
  
  useEffect(()=>{
    //if will go past maximum page, go to new max page
    if(props.timesheets && props.timesheets.length < (page+1) * props.rowsPerPage){
      props.setPage(Math.max(Math.ceil(props.timesheets.length / props.rowsPerPage)-1,0))
   }
  },[props.timesheets])

  useEffect(()=>{
    setColumnClick(props.columnClick)
  },[props.columnClick])

  const infoOrNa = (info) => {
    return info ? info : "N/A";
  };

  const handleChangePage = (event, newPage) => {
    props.setPage(newPage);
    props.setHasLoaded(false);
  };

  const handleChangeRowsPerPage = (event) => {
    props.setRowsPerPage(parseInt(event.target.value));
    props.setPage(0);
    props.setHasLoaded(false);
  };

  const columns = [
    { label: "Resource", accessor: "resource", sortable: true },
    { label: "Project", accessor: "project", sortable: true },
    { label: "Client", accessor: "client", sortable: true },
    { label: "Period", accessor: "period", sortable: true },
    { label: "Submitted on", accessor: "submitted_on", sortable: true },
    { label: "Hours", accessor: "hours", sortable: true},
    { label: "Days", accessor: "days", sortable: true},
    { label: "Status", accessor: "status", sortable: true },
    { label: "Invoice Number", accessor: "invoice_number", sortable: true },
    { label: "Payment Made", accessor: "payment_made", sortable: true },
    { label: "Consultant Paid", accessor: "consultant_paid", sortable: true },
    { label: "Invoice Document", accessor: "invoice_document", sortable: false },
   ];

  const handleSortingChange = (accessor) => {
    setColumnClick(!columnClick)
    const sortOrder =
    accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
    props.handleSorting(accessor, sortOrder);
 };

 const getTimesheetInvoiceInfo = (timesheet) =>{
  let invoice_numbers = []
  let payment_mades = []
  let consultant_paids = []
  let invoice_documents = []  
  for(let inv of timesheet.invoice){
    if(!inv.invoice_number){
      continue
    }

      invoice_numbers.push(inv)
      if(inv.payment_made) payment_mades.push(inv)
      if(inv.consultant_paid) consultant_paids.push(inv)
      if(inv.invoice_document) invoice_documents.push(inv)
  }
  
  return {
    invoice_numbers,
    payment_mades,
    consultant_paids,
    invoice_documents
  }

 }

  return (
    <>
      <TextPopUp
        open={Boolean(infoBody) && Boolean(infoTitle)}
        content={infoBody}
        title={infoTitle}
        onClose={(event) => {
          event.preventDefault();
          setInfoBody("");
          setInfoTitle("");
        }}
        fullWidth
      />
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              {columns.map(({label,accessor,sortable}) => {
                const cl = sortable
                ? sortField && sortField === accessor && order === "asc"
                 ? <ArrowDropUpIcon/>
                 : sortField && sortField === accessor && order === "desc"
                 ? <ArrowDropDownIcon/>
                 : ""
                : "";
                return <TableCell key={accessor} align='center' sx={{ fontSize: fonts.tableSize }} onClick={sortable ? () => handleSortingChange(accessor) : null} >{label}{cl}</TableCell>
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.timesheets.length > 0 ? (
              <>
                {props.timesheets.map((ts) => {
  
                  let invoice_obj = getTimesheetInvoiceInfo(ts)
                  return (
                  
                  <ExpandableRow columnClick={columnClick} setColumnClick={setColumnClick} expand={<AddInvoice profile={props.profile} invoices={ts.invoice} timesheet={ts.timesheet}
                  onUpdate={props.onUpdate? props.onUpdate : undefined} onSuccess={props.onSuccess}/>} 
                  alternate overrideColor={ts.timesheet.admin_submitted_id ? 'orange' : undefined}>
                    <SubmittedCell>
                      {`${ts.resource.first_name} ${ts.resource.last_name}`}
                    </SubmittedCell>
                    <SubmittedCell>{ts.project.project_name}</SubmittedCell>
                    <SubmittedCell>{ts.client.short_name}</SubmittedCell>
                    <SubmittedCell>
                      {moment
                        .utc(ts.timesheet.period_start_date)
                        .format("YYYY-MM-DD")
                        .toString()}
                    </SubmittedCell>
                    <SubmittedCell>
                      {ts.timesheet.submitted_date ? moment
                        .utc(ts.timesheet.submitted_date).local()
                        .format("YYYY-MM-DD")
                        .toString() : "N/A"}
                    </SubmittedCell>
                    <SubmittedCell>{ts.hours}</SubmittedCell>
                    <SubmittedCell>{ts.days}</SubmittedCell>
                    <SubmittedCell>
                      <ClickBox
                        onClick={(event) => {
                          event.preventDefault();
                          props.onEnvelope(ts);
                        }}
                        clickable={Boolean(ts.timesheet.status !== "pending")}
                      >
                        <Typography
                          color="green"
                          sx={{ textDecoration: "underline" }}
                        >
                          {ts.timesheet.status}
                        </Typography>
                      </ClickBox>
                    </SubmittedCell>
                    <SubmittedCell>
                      {invoice_obj.invoice_numbers.length !== 0 ? 
                      <>
                      {invoice_obj.invoice_numbers.map((inv)=>(
                        <ClickBox
                        onClick={(event) => {
                          event.preventDefault();
                          setInfoBody(
                            `Invoice Number: ${infoOrNa(
                              inv.invoice_number
                            )} | Invoice Date: ${
                              inv.invoice_date
                                ? moment(inv.invoice_date)
                                    .format("YYYY-MM-DD")
                                    .toString()
                                : "N/A"
                            }`
                          );
                          setInfoTitle("Invoice Info");
                        }}
                        clickable={Boolean(inv.invoice_number)}
                      >
                          <Typography
                            color="green"
                            sx={{ textDecoration: "underline" }}
                          >
                            {inv.invoice_number}
                          </Typography>
                      </ClickBox>
                      ))}
                      </> : <Typography>No Invoices</Typography>}
                    </SubmittedCell>
                    <SubmittedCell>
                      {invoice_obj.payment_mades.length > 0 ? <>
                        {invoice_obj.payment_mades.map((inv)=>(
                        <ClickBox
                        onClick={(event) => {
                          event.preventDefault();
                          setInfoTitle("Invoice Payment Info");
                          setInfoBody(
                            `Payment Made On: ${
                              inv.payment_date
                                ? moment(inv.payment_date)
                                    .format("YYYY-MM-DD")
                                    .toString()
                                : "N/A"
                            }`
                          );
                        }}
                        clickable={Boolean(inv.payment_made)}
                      >
                          <Typography
                            color="green"
                            sx={{ textDecoration: "underline" }}
                          >
                            {inv.invoice_number}
                          </Typography>
                      </ClickBox>
                      ))}
                      </> : <Typography>None</Typography>}
                    </SubmittedCell>
                    <SubmittedCell>
                      {invoice_obj.consultant_paids.length > 0 ? <>
                        {invoice_obj.consultant_paids.map((inv)=>(
                          <ClickBox
                          onClick={(event) => {
                            event.preventDefault();
                            setInfoTitle("Consultant Payment Info");
                            setInfoBody(
                              `Consultant Paid On: ${
                                inv.consultant_paid_date
                                  ? moment(inv.consultant_paid_date)
                                      .format("YYYY-MM-DD")
                                      .toString()
                                  : "N/A"
                              }`
                            );
                          }}
                          clickable={Boolean(inv.consultant_paid)}
                        >
                            <Typography
                              color="green"
                              sx={{ textDecoration: "underline" }}
                            >
                              {inv.invoice_number}
                            </Typography>
                        </ClickBox>
                      ))}
                      </> : <Typography>None</Typography>}
                      
                    </SubmittedCell>
                    <SubmittedCell>
                      {invoice_obj.invoice_documents.length > 0 ? <>
                        {invoice_obj.invoice_documents.map((inv)=>(
                        <ClickBox onClick={props.onClickInvoice? (event) => {event.preventDefault(); props.onClickInvoice(inv.invoice_document)} : undefined}>
                        <Typography
                            color="green"
                            sx={{ textDecoration: "underline" }}
                          >
                            {inv.invoice_number}
                          </Typography>
                      </ClickBox>
                      ))}
                      </> : <Typography>None</Typography>}
                      
                    </SubmittedCell>
                  </ExpandableRow>
                )})}
              </>
            ) : (
              <></>
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          page={props.page}
          count={props.timesheets.length < props.rowsPerPage ? props.timesheets.length : -1}
          rowsPerPage={props.rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </>
  );
}

//count={props.timesheets.length}

AdminSubmittedDisplay.propTypes = {
  /**
   * list of objects that represent timesheets, following schema in db
   */
  timesheets: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * function called when clicking status of timesheet
   */
  onEnvelope: PropTypes.func,
  /**
   * function used to handle the sorting of the given timesheets
   */
  handleSorting: PropTypes.func,
  /**
   * function called when clicking an invoice number
   */
  onClickInvoice: PropTypes.func,
  /**
   * profile of current user viewing timesheets, object following db schema
   */
  profile: PropTypes.object.isRequired,
  /**
   * function called when tables are updated
   */
  onUpdate: PropTypes.func,
  /**
   * boolean toggle, update to close all expandable invoices
   */
  columnClick: PropTypes.bool
};

export default AdminSubmittedDisplay;
